import { DashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery } from '@metorial/dashboard-sdk';
import { createLoader } from '@metorial/data-hooks';
import { isMetorialSDKError } from '@metorial/util-endpoint';
import { withAuth } from '../../user';

type ProviderConfigSchemaQuery =
  DashboardInstanceProviderDeploymentsConfigsGetConfigSchemaQuery;

// BlackOS lists every library integration before it is built. Until a build is discovered
// the provider has no version, and the API answers 400 for its config schema. Treat that as
// "no schema yet" (data = null) instead of an error; the provider page shows it as building.
let isUnbuiltProviderError = (err: unknown) =>
  isMetorialSDKError(err) &&
  err.response.status == 400 &&
  /Unable to determine provider version|Specification not discovered/.test(
    err.response.message ?? ''
  );

export let providerConfigSchemaLoader = createLoader({
  name: 'providerConfigSchema',
  parents: [],
  fetch: async (i: { instanceId: string } & ProviderConfigSchemaQuery) => {
    try {
      return await withAuth(sdk =>
        sdk.providerDeployments.configs.getConfigSchema(i.instanceId, i)
      );
    } catch (err) {
      if (isUnbuiltProviderError(err)) return null;
      throw err;
    }
  },
  mutators: {}
});

export let useProviderConfigSchemaTarget = (
  instanceId: string | null | undefined,
  query?: ProviderConfigSchemaQuery | null
) => {
  let data = providerConfigSchemaLoader.use(
    instanceId && query ? { instanceId, ...query } : null
  );

  return data;
};

export let useProviderDeploymentConfigSchema = (
  instanceId: string | null | undefined,
  providerDeploymentId: string | null | undefined
) => {
  let data = useProviderConfigSchemaTarget(
    instanceId,
    providerDeploymentId ? { providerDeploymentId } : null
  );

  return data;
};
